/**
 * add fake delay
 * @param ms number of milliseconds delay
 * @returns
 */
export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(() => resolve(""), ms));
}
